window.BOLD = window.BOLD || {};
BOLD.BMS = BOLD.BMS || {};

BOLD.BMS.OptionsPreselection = function(product){
  if(!(this instanceof BOLD.BMS.OptionsPreselection)){
    throw new Error('BOLD.BMS.OptionsPreselection: Unable to run constructor as a function')
  }

  this.init(product);
}

BOLD.BMS.OptionsPreselection.defaults = {
  defaultPreselectTemplate:'<div style="display:none">{{{ optionElement }}} {{#optionElement}} {{{ optionValueElement }}} {{/optionElement}}</div>',
  specificPreselectOptionTemplates:{}
}

BOLD.BMS.OptionsPreselection.prototype = {
  init:function(product, options){
    //If product has no tags, we already know we have nothing to do.
    if(!product.tags || !product.tags.length){
      return;
    }

    var preselectionTags = product.tags.filter(function(tag){ return tag.toLowerCase().indexOf('preselect:') === 0 });

    //If none of the tags imply a preselection, we have nothing to do.
    if(!preselectionTags.length){
      return;
    }

    this.productId = product.id;
    this.saveOptions(options);
    this.savePreselections(preselectionTags);
    this.setupEventListeners();
    this.applyPreselects();
  },
  saveOptions:function(options){
    this.options = {};
    options = options || {};
    for(var key in BOLD.BMS.OptionsPreselection.defaults){
      this.options[key] = (typeof options[key] !== "undefined" ? options[key] : BOLD.BMS.OptionsPreselection.defaults[key]);
    }
  },
  savePreselections:function(tags){
    this.preselections = tags.reduce(function(acc, tag){
      var data = tag.split('=');
      acc[data[0].split(':')[1].trim()] = data[1].trim();
      return acc;
    }, {});
  },
  applyPreselects:function(){
    var optionProduct = BOLD.options.app.getOptionProductByProductId(this.productId);
    // If the option product isn't loaded yet, nothing to do.
    if(!optionProduct){
      return;
    }
    //Brief setTimeout to make sure that any other event listeners that apply custom templates won't reset our special (probably hidden) preselection ones
    setTimeout(function(){

      for(var os=0; os<optionProduct.optionSets.length; os++){
        var optionSet = optionProduct.optionSets[os];
        for(var o=0; o<optionSet.options.length; o++){
          var option = optionSet.options[o];

          var preselectValue = this.preselections[option.internalName] || this.preselections[option.publicName];
          if(preselectValue){
            var preselectTemplate = this.options.specificPreselectOptionTemplates[option.internalName] ||  this.options.specificPreselectOptionTemplates[option.publicName] || this.options.defaultPreselectTemplate;
            preselectTemplate && BOLD.options.setTemplate(option.className, preselectTemplate);
            option.receiveValue(preselectValue);
          }
        }
      }
    }.bind(this), 10);

  },
  setupEventListeners:function(){
    BOLD.options.app.on('options_loaded', this.applyPreselects, this);
    BOLD.common.eventEmitter.on('CLARA.loaded', this.applyPreselects, this);
  }
}
